import { useGetTemplates } from '@modules/dashboard/hooks';
import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Paper, Stack, Typography } from '@mui/material';
import { DashboardListItemViewFragment } from 'generated/graphql';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CreateNewDashboardMenu } from './CreateNewDashboardMenu';
import { CreateNewDashboardTemplatePreview } from './CreateNewDashboardTemplatePreview';

export const CreateNewDashboard = () => {
  const [searchParams] = useSearchParams();
  const templateID = searchParams.get('templateID');
  const [selectedTemplate, setSelectedTemplate] =
    useState<DashboardListItemViewFragment>();

  const navigate = useNavigate();

  const onClose = () => navigate(-1);

  const onTemplatesLoaded = (templates: DashboardListItemViewFragment[]) => {
    if (!!selectedTemplate) {
      return;
    }

    if (templateID) {
      const template = templates?.find(
        (template) => template.id === templateID,
      );
      setSelectedTemplate(template);
    } else {
      setSelectedTemplate(templates[0]);
    }
  };

  const { templates, loading } = useGetTemplates({
    onCompleted: onTemplatesLoaded,
  });

  return (
    <Stack
      spacing={4}
      pt={4}
      mx={{ md: -3, lg: 0 }}
      sx={{ overflowY: 'hidden' }}
    >
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h5">Start Creating a New Dashboard</Typography>
        <IconButton aria-label="close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Stack>
      <Stack direction="row" alignItems="stretch" minHeight="80vh">
        <Box width={'100%'} maxWidth={360}>
          <Paper
            variant="outlined"
            sx={{
              borderRadius: 0,
              borderTopLeftRadius: 16,
              borderBottomLeftRadius: 16,
              p: 2,
              height: '85vh',
              borderRight: 'none',
              overflow: 'auto',
            }}
          >
            <CreateNewDashboardMenu
              templates={templates ?? []}
              isLoadingTemplates={loading}
              selectedTemplate={selectedTemplate}
              onTemplateSelect={setSelectedTemplate}
            />
          </Paper>
        </Box>
        <Box width="100%" minWidth={640}>
          <Paper
            variant="outlined"
            sx={{
              borderRadius: 0,
              borderTopRightRadius: 16,
              borderBottomRightRadius: 16,
              height: '85vh',
            }}
          >
            <CreateNewDashboardTemplatePreview
              isLoadingTemplates={loading}
              selectedTemplate={selectedTemplate}
            />
          </Paper>
        </Box>
      </Stack>
    </Stack>
  );
};
